import { render, staticRenderFns } from "./PresentationProductListAddToStore.vue?vue&type=template&id=c51a4bba"
import script from "./PresentationProductListAddToStore.vue?vue&type=script&lang=js"
export * from "./PresentationProductListAddToStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c51a4bba')) {
      api.createRecord('c51a4bba', component.options)
    } else {
      api.reload('c51a4bba', component.options)
    }
    module.hot.accept("./PresentationProductListAddToStore.vue?vue&type=template&id=c51a4bba", function () {
      api.rerender('c51a4bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Application/Customers/components/Presentations/PresentationProductListAddToStore.vue"
export default component.exports